"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleChip = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Icon_1 = require("./Icon");
const PresentationContext_1 = require("./PresentationContext");
const Css_1 = require("../Css");
const useTestIds_1 = require("../utils/useTestIds");
function ToggleChip(props) {
    const { text, onClick, xss = {}, disabled = false } = props;
    const { fieldProps } = (0, PresentationContext_1.usePresentationContext)();
    // If compact, then use a smaller type scale
    const compact = fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.compact;
    const tid = (0, useTestIds_1.useTestIds)(props, "chip");
    return ((0, jsx_runtime_1.jsxs)("button", { type: "button", css: {
            ...Css_1.Css[compact ? "xs" : "sm"].dif.aic.br16.pl1
                // Use a lower right-padding to get closer to the `X` circle when not disabled
                .prPx(2)
                .pyPx(2)
                .gray900.bgGray200.if(disabled)
                .gray600.pr1.mhPx(compact ? 20 : 28).$,
            ":hover:not(:disabled)": Css_1.Css.bgGray300.$,
            ":disabled": Css_1.Css.cursorNotAllowed.$,
            ...xss,
        }, disabled: disabled, onClick: onClick, ...tid, children: [(0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.prPx(6).tal.lineClamp1.wbba.if(disabled).pr0.$, title: text, children: text }), !disabled && ((0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.fs0.br16.bgGray400.$, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "x", color: Css_1.Palette.Gray700, inc: compact ? 2 : undefined }) }))] }));
}
exports.ToggleChip = ToggleChip;
